import { resolveNoContent, resolveWithBody } from "./Utils/utils";
import { usePromisedRequest as promiseRequest } from "../Common/request";
import { PricingDefinition, RawAttribute } from "../Common/Pricing/types";

export const DisplayProvider = {
    Stripe: "Stripe",
    Przelewy24: "Przelewy24",
};
export type DisplayProviderType = (typeof DisplayProvider)[keyof typeof DisplayProvider];

export type ConfiguredPaymentGateway = {
    provider: DisplayProviderType;
    currencies: Array<string>;
    configId: string;
    configName: string;
};

export type UpdatePricingRequest = {
    id: number;
    eventId: number;
    registrationStageId: number;
    rawAttributes: Array<RawAttribute>;
};

export default {
    removePricing(eventId: number, pricingId: number): Promise<void> {
        return promiseRequest({
            url: `/api/admin/events/${eventId}/pricing-definitions/${pricingId}`,
            json: true,
            method: "delete",
        }).then(resolveNoContent());
    },
    //TODO: Remove
    getAvailableStages(eventId) {
        return promiseRequest({
            url: `/api/admin/events/${eventId}/pricing-available-stages`,
            json: true,
            method: "get",
        }).then(res => {
            if (res.statusCode !== 200) {
                throw Error("Could not get registration stages.");
            }

            return res.body;
        });
    },
    getAllDefinitions(eventId: number): Promise<Array<PricingDefinition>> {
        return promiseRequest<Array<PricingDefinition>>({
            url: `/api/admin/events/${eventId}/pricing-definitions`,
            json: true,
            method: "get",
        }).then(resolveWithBody());
    },
    updatePricing(updateObject: UpdatePricingRequest): Promise<void> {
        return promiseRequest({
            url: `/api/admin/events/${updateObject.eventId}/pricing-definitions/${updateObject.id}`,
            json: {
                id: updateObject.id,
                eventId: updateObject.eventId,
                registrationStageId: updateObject.registrationStageId,
                rawAttributes: updateObject.rawAttributes,
            },
            method: "put",
        }).then(resolveNoContent());
    },
    addNewPricing(eventId: number, stageId: number, rawAttributes: Array<RawAttribute>): Promise<void> {
        return promiseRequest({
            url: `/api/admin/events/${eventId}/pricing-definitions`,
            json: {
                eventId: eventId,
                registrationStageId: stageId,
                rawAttributes: rawAttributes,
            },
            method: "post",
        }).then(resolveNoContent());
    },

    //Payment gateways configuration

    configurePaymentGateway(eventId, { currencies, configId }) {
        return promiseRequest({
            url: `/api/admin/events/${eventId}/payment-gateways`,
            method: "post",
            json: {
                eventId: eventId,
                currencies: currencies,
                configId: configId,
            },
        }).then(resolveNoContent());
    },
    getConfiguredPaymentGateway(eventId: number): Promise<ConfiguredPaymentGateway> {
        return promiseRequest<ConfiguredPaymentGateway>({
            url: `/api/admin/events/${eventId}/payment-gateways`,
            json: true,
            method: "get",
        }).then(resolveWithBody());
    },
};
